import React from 'react';
import './ActionButton.css';

/*
  Botón nativo con tipos numéricos (1, 2, ...)
  Soporte de loading integrado
*/
export default function ActionButton({
    children,
    onClick,
    loading = false,
    disabled = false,
    type = '1',
    width = '100%',
    customStyles = {}
}) {
    // Determina la clase según el tipo
    let typeClass = 'btn-1';
    if (type === '2') typeClass = 'btn-2';

    // Lógica de anchura
    const style = {
        width: typeof width === 'number' ? `${width}px` : width,
        minWidth: width === '100%' ? 'none' : '220px',
        opacity: loading ? 0.7 : 1,
        cursor: loading || disabled ? 'default' : 'pointer',
        ...customStyles
    };

    return (
        <button
            type="button"
            onClick={onClick}
            disabled={disabled || loading}
            className={`action-button-dynamic ${typeClass}`}
            style={style}
        >
            {loading && (
                <span className={`action-button-spinner ${type === '2' ? 'spinner-dark' : ''}`} />
            )}
            {children}
        </button>
    );
}